import React, { useState } from 'react';
import { Alert, AlertTitle } from '@material-ui/lab';
import parse from 'html-react-parser';
import { useDispatch } from 'react-redux';
import { Box, fade } from '@material-ui/core';
import Checkbox from '@material-ui/core/Checkbox';
import TextField from '@material-ui/core/TextField';
import IntlMessages from '../../../utils/IntlMessages';
import Button from '@material-ui/core/Button';
import { AuhMethods } from '../../../../services/auth';
import ContentLoader from '../../ContentLoader';
import makeStyles from '@material-ui/core/styles/makeStyles';
import queryString from 'query-string';
import CmtImage from '../../../../@coremat/CmtImage';
import Typography from '@material-ui/core/Typography';
import { CurrentAuthMethod } from '../../../constants/AppConstants';
import AuthWrapper from './AuthWrapper';
import { NavLink } from 'react-router-dom';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import axios from 'axios';
import { WBPCountries } from '../../../utils/dateHelper';
import MenuItem from '@material-ui/core/MenuItem';

const useStyles = makeStyles(theme => ({
  authThumb: {
    backgroundColor: fade(theme.palette.primary.main, 0.12),
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    [theme.breakpoints.up('md')]: {
      width: '50%',
      order: 2,
    },
  },
  authContent: {
    padding: 30,
    [theme.breakpoints.up('md')]: {
      width: props => (props.variant === 'default' ? '50%' : '100%'),
      order: 1,
    },
    [theme.breakpoints.up('xl')]: {
      padding: 50,
    },
  },
  titleRoot: {
    marginBottom: 14,
    color: theme.palette.text.primary,
  },
  textFieldRoot: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: fade(theme.palette.common.dark, 0.12),
    },
    marginRight: 4,
  },
  textCapital: {
    textTransform: 'capitalize',
  },
  textAcc: {
    textAlign: 'center',
    '& a': {
      marginLeft: 4,
    },
  },
  alrTextRoot: {
    textAlign: 'center',
    [theme.breakpoints.up('sm')]: {
      textAlign: 'right',
    },
  },
}));

//variant = 'default', 'standard', 'bgColor'
const SignUp = ({ method = CurrentAuthMethod, variant = 'default', wrapperVariant = 'default' }) => {
  const params = queryString.parse(window.location.search.substring(1));
  var owner = '';
  if (params != null && params.owner != null) {
    owner = params.owner;
  }

  var logoImage = '/images/webbookingpro_logo.png';
  var hostName = window.location.hostname;

  if (hostName === 'app.mikos.io' && variant != 'travel') {
    logoImage = '/images/logo-mikos.png';
    owner = 34703;
  }

  if (owner === '35042') {
    logoImage = 'https://cdn.webbookingpro.com/images/hotels/hotellogo_33856_aqo19aolmel7jork3i6z.jpg';
    owner = 35042;
  }

  const [fName, setFName] = useState('');
  const [errorMsg, setErrorMsg] = useState('');
  const [successMsg, setSuccessMsg] = useState('');
  const [lName, setLName] = useState('');
  const [email, setEmail] = useState('');
  const [error, setError] = useState(false);
  const [phone, setPhone] = useState('');
  const [showSuccess, setShowSuccess] = useState(false);
  const [password, setPassword] = useState('');
  const [propertyType, setPropertyType] = useState('hotel');
  const [propertyName, setPropertyName] = useState('');

  const [taName, settaName] = useState('');
  const [taURL, settaURL] = useState('');
  const [taAddress, settaAddress] = useState('');
  const [taAddress2, settaAddress2] = useState('');
  const [taPostal, settaPostal] = useState('');
  const [taCity, settaCity] = useState('');
  const [taCountry, settaCountry] = useState('');
  const [taVAT, settaVAT] = useState('');
  const [taPIN, settaPIN] = useState('');

  const [taUserName, settaUserName] = useState('');

  const dispatch = useDispatch();
  const classes = useStyles({ variant });
  const [state, setState] = React.useState({
    feature1: true,
    feature2: false,
    feature3: false,
    feature4: false,
  });

  const onSubmit = () => {
    var senddata = {};
    senddata = {
      Action: 'create_account',
      Data: {
        FName: fName,
        LName: lName,
        PropertyType: propertyType,
        PropertyName: propertyName,
        Email: email,
        Phone: phone,
        Feature1: state.feature1,
        Feature2: state.feature2,
        Feature3: state.feature3,
        Owner: owner,
      },
    };
    if (variant == 'travel') {
      senddata = {
        Action: 'create_travelaccount',
        Data: {
          Name: taName,
          URL: taURL,
          Address: taAddress,
          Address2: taAddress2,
          Zip: taPostal,
          City: taCity,
          Country: taCountry,
          VAT: taVAT,
          PIN: taPIN,
          Username: taUserName,
          FName: fName,
          LName: lName,
          Email: email,
          Phone: phone,
          Owner: owner,
        },
      };
    }

    // const { intl } = this.props;

    /*if (this.state.roomid == 0) {
      alert(intl.formatMessage({ id: 'error.noRoomType' }));
      return;
    }
    if (this.state.nrrooms == 0) {
      alert(intl.formatMessage({ id: 'error.noRoomsSelected' }));
      return;
    }
    if (this.state.guestName == '') {
      alert(intl.formatMessage({ id: 'error.noGuestName' }));
      return;
    }
    if (this.state.date1 > this.state.date2) {
      alert(intl.formatMessage({ id: 'error.dates1' }));
      return;
    }*/

    // alert(JSON.stringify(senddata));
    //  return;
    if (variant != 'travel') {
      if (fName == '' || lName == '' || email == '' || propertyName == '') {
        setErrorMsg('Please fill all requested information.');
        setError(true);
        return;
      }
    }

    if (variant == 'travel') {
      if (taVAT == '' && taPIN == '') {
        setErrorMsg('Either PIN/TIN number of VAT number is required.');
        setError(true);
        return;
      }
      if (fName == '' || lName == '' || email == '' || taName == '' || taUserName == '') {
        setErrorMsg('Please fill all mandatory information.');
        setError(true);
        return;
      }
    }

    if (state.feature1 == false && state.feature2 == false && state.feature3 == false) {
      setError(true);
      return;
    }
    setError(false);
    //alert(JSON.stringify(senddata));
    //return;

    var pmsUrl = 'https://secure.webbookingpro.com/api/pms.php';

    axios.post(pmsUrl, senddata).then(res => {
      const resources = res.data;

      if (res.data != null) {
        if (res.data.success == 'false') {
          setErrorMsg(res.data.msg);
          setError(true);
        } else {
          setShowSuccess(true);
          if (res.data.msg != null) setSuccessMsg(res.data.msg);
        }
        //      alert(mydate + ' ' + mydate2 + ' ' + room + ' ' + resources.Data);

        //      const obj = JSON.parse(resources.Data);
        //      console.log(obj);
      }
    });
  };

  const handleChange = event => {
    setState({ ...state, [event.target.name]: event.target.checked });
  };

  return (
    <AuthWrapper variant={wrapperVariant}>
      {variant === 'default' ? (
        <Box className={classes.authThumb}>
          <CmtImage src={'/images/auth/sign-up-img.png'} />
        </Box>
      ) : null}

      <Box className={classes.authContent}>
        <Box mb={7} display="flex" alignItems="center" justifyContent="center">
          {variant == 'travel' && <CmtImage height="150px" src={logoImage} />}
          {variant != 'travel' && <CmtImage src={logoImage} />}
        </Box>
        {error && (
          <Box mb={2}>
            <Alert severity="error">
              <AlertTitle>Error</AlertTitle>
              {parse(errorMsg)}
            </Alert>
          </Box>
        )}
        {showSuccess && (
          <>
            <Box mb={2}>
              <Alert severity="success">
                <AlertTitle>Success</AlertTitle>
                {variant != 'travel' && <IntlMessages id="register.success" />}
                {variant == 'travel' && (
                  <>
                    <IntlMessages id="register.successTA" />
                    {parse(successMsg)} <IntlMessages id="register.successTA2" />
                  </>
                )}
              </Alert>
            </Box>
            {variant != 'travel' && (
              <Box mb={2}>
                <NavLink to="/signin">
                  <IntlMessages id="register.sign" />
                </NavLink>
              </Box>
            )}
          </>
        )}
        {!showSuccess && (
          <>
            {variant == 'travel' && (
              <>
                <Alert severity="info">
                  <IntlMessages id="register.registerTA1" />
                </Alert>
              </>
            )}
            {variant != 'travel' && (
              <Typography component="div" variant="h1" className={classes.titleRoot}>
                <IntlMessages id="register.createAccount" />
              </Typography>
            )}
            {variant != 'travel' && (
              <Typography component="div" variant="h3" className={classes.titleRoot}>
                <IntlMessages id="register.createAccount2" />
              </Typography>
            )}

            {variant == 'travel' && (
              <form>
                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.taName" />}
                    fullWidth
                    onChange={event => settaName(event.target.value)}
                    defaultValue={taName}
                    required
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.taURL" />}
                    fullWidth
                    onChange={event => settaURL(event.target.value)}
                    defaultValue={taURL}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.taAddress" />}
                    fullWidth
                    onChange={event => settaAddress(event.target.value)}
                    defaultValue={taAddress}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.taAddress2" />}
                    fullWidth
                    onChange={event => settaAddress(event.target.value)}
                    defaultValue={taAddress2}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.taPostal" />}
                    fullWidth
                    onChange={event => settaPostal(event.target.value)}
                    defaultValue={taPostal}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.taCity" />}
                    fullWidth
                    onChange={event => settaCity(event.target.value)}
                    defaultValue={taCity}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.taCountry" />}
                    fullWidth
                    onChange={event => settaCountry(event.target.value)}
                    defaultValue={taCountry}
                    margin="normal"
                    select
                    variant="outlined"
                    className={classes.textFieldRoot}>
                    {WBPCountries.map(item => (
                      <MenuItem value={item.abbrv}>{item.name}</MenuItem>
                    ))}
                  </TextField>
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.taVAT" />}
                    fullWidth
                    onChange={event => settaVAT(event.target.value)}
                    defaultValue={taVAT}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.taPIN" />}
                    fullWidth
                    onChange={event => settaPIN(event.target.value)}
                    defaultValue={taPIN}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.phone" />}
                    fullWidth
                    onChange={event => setPhone(event.target.value)}
                    defaultValue={phone}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.fname" />}
                    onChange={event => setFName(event.target.value)}
                    defaultValue={fName}
                    margin="normal"
                    fullWidth
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                  <TextField
                    label={<IntlMessages id="register.lname" />}
                    onChange={event => setLName(event.target.value)}
                    defaultValue={lName}
                    margin="normal"
                    fullWidth
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.email" />}
                    fullWidth
                    onChange={event => setEmail(event.target.value)}
                    defaultValue={email}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.taUserName" />}
                    fullWidth
                    onChange={event => settaUserName(event.target.value)}
                    defaultValue={taUserName}
                    required
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ sm: 'center' }}
                  justifyContent={{ sm: 'space-between' }}
                  mb={3}>
                  <Box mb={{ xs: 2, sm: 0 }}>
                    <Button onClick={onSubmit} variant="contained" color="primary">
                      {variant == 'travel' && <IntlMessages id="register.registerAgency" />}
                    </Button>
                  </Box>
                </Box>
              </form>
            )}

            {variant != 'travel' && (
              <form>
                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.fname" />}
                    onChange={event => setFName(event.target.value)}
                    defaultValue={fName}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                  <TextField
                    label={<IntlMessages id="register.lname" />}
                    onChange={event => setLName(event.target.value)}
                    defaultValue={lName}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.email" />}
                    fullWidth
                    onChange={event => setEmail(event.target.value)}
                    defaultValue={email}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.phone" />}
                    fullWidth
                    onChange={event => setPhone(event.target.value)}
                    defaultValue={phone}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>
                <Box mb={2}>
                  <FormControl component="fieldset">
                    <FormLabel component="legend">
                      <IntlMessages id="register.propertyType" />
                    </FormLabel>
                    <RadioGroup
                      aria-label="propertyType"
                      name="propertyType"
                      value={propertyType}
                      onChange={event => setPropertyType(event.target.value)}>
                      <FormControlLabel
                        value="hotel"
                        control={<Radio />}
                        label={<IntlMessages id="register.propertyTypeHotel" />}
                      />
                      <FormControlLabel
                        value="group"
                        control={<Radio />}
                        label={<IntlMessages id="register.propertyTypeGroup" />}
                      />
                      <FormControlLabel
                        value="hostel"
                        control={<Radio />}
                        label={<IntlMessages id="register.propertyTypeHostel" />}
                      />
                      <FormControlLabel
                        value="bnb"
                        control={<Radio />}
                        label={<IntlMessages id="register.propertyTypeBNB" />}
                      />
                      <FormControlLabel
                        value="vc"
                        control={<Radio />}
                        label={<IntlMessages id="register.propertyTypeVacantRental" />}
                      />
                    </RadioGroup>
                  </FormControl>
                </Box>
                <Box mb={2}>
                  <TextField
                    label={<IntlMessages id="register.propertyName" />}
                    fullWidth
                    onChange={event => setPropertyName(event.target.value)}
                    defaultValue={propertyName}
                    margin="normal"
                    variant="outlined"
                    className={classes.textFieldRoot}
                  />
                </Box>

                <Box
                  display="flex"
                  flexDirection={{ xs: 'column', sm: 'row' }}
                  alignItems={{ sm: 'center' }}
                  justifyContent={{ sm: 'space-between' }}
                  mb={3}>
                  <Box mb={{ xs: 2, sm: 0 }}>
                    <Button onClick={onSubmit} variant="contained" color="primary">
                      {variant != 'travel' && <IntlMessages id="register.startFreeTrial" />}
                    </Button>
                  </Box>

                  {variant != 'travel' && (
                    <Typography className={classes.alrTextRoot}>
                      <NavLink to="/signin">
                        <IntlMessages id="signUp.alreadyMember" />
                      </NavLink>
                    </Typography>
                  )}
                </Box>
              </form>
            )}

            <Box mb={3}>{dispatch(AuhMethods[method].getSocialMediaIcons())}</Box>

            {variant != 'travel' && (
              <Typography className={classes.textAcc}>
                Have an account?
                <NavLink to="/signin">Sign In</NavLink>
              </Typography>
            )}
          </>
        )}
        <ContentLoader />
      </Box>
    </AuthWrapper>
  );
};

export default SignUp;
